
import { defineComponent } from 'vue';
import { endpointFooterComposition } from '../services'

import CovidEndpointFooterSections from './footer/covid-endpoint-footer-sections.vue';

export default defineComponent({
	components: {
		CovidEndpointFooterSections,
	},
    setup() {
        return { ...endpointFooterComposition() }
    },
})
